import React from "react";
import styles from "./HamperOverview.module.css";
import * as fa from "react-icons/fa";

function HamperOverview({hamper}) {
  return (
    <div className={styles.HamperOverview}>
      <div className={styles.HamperName}>{hamper.Name}</div>
      <div className={styles.HamperPrice}>£{hamper.Price}</div>
      <div className={styles.TrustTicks}>
        {hamper.TrustTicks && hamper.TrustTicks.length > 0
          ? hamper.TrustTicks.map((tic, index) => (
              <div key={index} className={styles.Tic}>
                <fa.FaCheck className={styles.TickIcon} />
                {tic.Description}
              </div>
            ))
          : null}
      </div>
    </div>
  );
}

export default HamperOverview;
